import { CorpTypeList1 } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC030001_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "登録者様のご確認",
    keyword: "businessOwnerClass",
    type: "radio",
    radioPropsList: TkGetCodeList(CorpTypeList1),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "法人格を選択してください。なお、新規の契約は社会福祉法人のみとなります。",
    guideMessage:
      "※社会福祉法人以外の場合は契約ができません。なお、学校法人の場合は画面下部の「問い合せ」ボタンから機構へお問い合わせください",
  },
  {
    title: "経営している主な施設の種類",
    keyword: "mainFacilityKinds",
    type: "facilityType",
    requiredIcon: true,
    isSCRC030001: true,
    helpicon: true,
    helpText:
      "経営している主な施設・事業を選択（複数選択可能）してください。一覧に経営している施設・事業がない場合は契約ができません。",
  },
  {
    title: "法人名（ｶﾅ）",
    keyword: "corpNameKana",
    requiredIcon: true,
    helpicon: true,
    helpText: "法人格を除いて法人名称（フリガナ）を入力してください。",
    convertToHalfwidth: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "法人名",
    keyword: "corpName",
    requiredIcon: true,
    helpicon: true,
    helpText: "法人格を除いて法人名称を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者職名",
    keyword: "directorTitle",
    requiredIcon: true,
    helpicon: true,
    helpText: "代表者の役職名（理事長、会長等）を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "代表者氏名",
    keyword: "directorName",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    helpText: "代表者（理事長、会長等）の氏名を入力してください。",
  },
  {
    title: "法人所在地郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "履歴事項全部証明書に記載されている主たる事務所の住所の郵便番号を入力してください。",
  },
  {
    title: "法人所在地",
    keyword: "locationGroup",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,
    helpicon: true,
    helpText:
      "履歴事項全部証明書に記載されている主たる事務所の住所を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "法人番号",
    keyword: "corpNo",
    helpicon: true,
    helpText: "日本の国税庁が指定する１３桁の番号を入力してください。",
    inputProps: { maxLength: 13 },
  },
  {
    title: "代表者電話番号",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText: "法人の代表電話番号を入力してください。",
  },
  {
    title: "代表FAX番号",
    keyword: "fax",
    type: "phoneNum",
    helpicon: true,
    helpText: "法人の代表FAX番号を入力してください。",
  },
  {
    title: "担当者 所属部署名",
    keyword: "managerDeployment",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "共済契約申込み手続きを行うご担当者の所属部署名を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "担当者 役職",
    keyword: "managerPosition",
    requiredIcon: true,
    helpicon: true,
    helpText: "共済契約申込み手続きを行うご担当者の役職を入力してください。",
    inputProps: { maxLength: 85 },
  },
  {
    title: "担当者 氏名",
    keyword: "managerName",
    requiredIcon: true,
    type: "name",
  },
  {
    title: "担当者 電話番号",
    keyword: "managerTel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "共済契約申込み手続きを行うご担当者の連絡先電話番号を入力してください。",
  },
  {
    title: "連絡先メールアドレス",
    keyword: "managerEmail",
    type: "mail",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        共済契約申込み手続きを行ううえでの連絡先メールアドレスを入力してください。
        <br></br>
        ※今後、当該メールアドレスに機構からの各種連絡が届くため、ご担当者の方とご担当者以外の方も確認できるメールアドレスを登録してください。
      </>
    ),
    inputProps: { maxLength: 85 },
  },
  {
    title: "連絡先メールアドレス（確認用）",
    keyword: "emailConfirm",
    type: "mail",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
  },
];

const schema = {
  mainFacilityKinds: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  businessOwnerClass: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  corpNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  corpName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorTitle: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  locationGroup: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : !data.city.match(/^[^ -~｡-ﾟ]+$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
        address: !data.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.address.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : !data.address.match(/^[^ -~｡-ﾟ]+$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
  corpNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 13,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "13"),
    },
    minLength: {
      value: 13,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "13"),
    },
  },
  tel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "10"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
    },
  },
  fax: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "10"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
    },
  },
  managerDeployment: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  managerPosition: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  managerName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  managerTel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 10,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "10"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
    },
  },
  managerEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  emailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { fakeTableList, schema };
